import React from "react";
import { Tooltip, Typography } from "antd";
import { FileOutlined } from "@ant-design/icons";

const { Text } = Typography;

// How many trailing characters stay pinned when the name is truncated. MCAP
// names look like `raasdata_test20260225_104118_20260225_104118_094.mcap`:
// the prefix is boilerplate, the tail is what tells two files apart, so the
// tail must survive. 18 keeps `_104118_094.mcap` intact.
const TAIL_LENGTH = 18;

/**
 * Filename cell that truncates in the MIDDLE rather than at the end.
 *
 * antd's `ellipsis` clips the tail, which would hide the only part of an MCAP
 * filename that differs between rows. Splitting into a shrinking head and a
 * pinned tail lets flexbox do the truncation, so the cut point follows the
 * real column width without measuring anything in JS. See `.mcap-fname*` in
 * robot-logs.css.
 */
const LogFileNameCell = ({ filename }) => {
  if (!filename) {
    return <Text type="secondary">-</Text>;
  }

  const splitAt = Math.max(0, filename.length - TAIL_LENGTH);
  const head = filename.slice(0, splitAt);
  const tail = filename.slice(splitAt);

  return (
    <div className="mcap-file-cell">
      <FileOutlined />
      <Tooltip title={filename} placement="topLeft">
        <span className="mcap-fname">
          <span className="mcap-fname__head">{head}</span>
          <span className="mcap-fname__tail">{tail}</span>
        </span>
      </Tooltip>
      <Text copyable={{ text: filename, tooltips: ["Copy filename", "Copied"] }} />
    </div>
  );
};

export default LogFileNameCell;
